export const data =  [
    {
        id: 1,
        wariableForRent: "Bomber Pants",
        wariableForRent2:"ICE level 2",
        levelOrRank: "2",
        multiplier: "25%",
        rentalPrice: "100 ICE/Day",
        rentalTerm: "60Days",
        action: "Rent Me"
    },
    {
        id: 2,
        wariableForRent: "Bomber Pants",
        wariableForRent2:"ICE level 3",
        levelOrRank: "3",
        multiplier: "25%",
        rentalPrice: "100 ICE/Day",
        rentalTerm: "40Days",
        action: "Rent Me"
    },
        {
        id: 3,
        wariableForRent: "Bomber Pants",
        wariableForRent2:"ICE level 7",
        levelOrRank: "7",
        multiplier: "50%",
        rentalPrice: "100 ICE/Day",
        rentalTerm: "70 Days",
        action: "Rent Me"
    },
    {
        id: 4,
        wariableForRent: "Fomber Pants",
        wariableForRent2:"ICE level 2",
        levelOrRank: "2",
        multiplier: "25%",
        rentalPrice: "100 ICE/Day",
        rentalTerm: "60Days",
        action: "Rent Me"
    },
    {
        id: 5,
        wariableForRent: "Bomber Pants",
        wariableForRent2:"ICE level 2",
        levelOrRank: "2",
        multiplier: "25%",
        rentalPrice: "100 ICE/Day",
        rentalTerm: "60Days",
        action: "Rent Me"
    },
        {
        id: 6,
        wariableForRent: "Bomber Pants",
        wariableForRent2:"ICE level 2",
        levelOrRank: "2",
        multiplier: "25%",
        rentalPrice: "100 ICE/Day",
        rentalTerm: "60Days",
        action: "Rent Me"
    },    
    // {
    //     id: 7,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // },
    // {
    //     id: 8,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // },
    //     {
    //     id: 9,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // },
    // {
    //     id: 10,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // },
    // {
    //     id: 11,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // },
    //     {
    //     id: 12,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // },
    // {
    //     id: 13,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // },
    // {
    //     id: 14,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // },
    // //     {
    //     id: 15,
    //     wariableForRent: "Bomber Pants",
    //     wariableForRent2:"ICE level 2",
    //     levelOrRank: "2",
    //     multiplier: "25%",
    //     rentalPrice: "100 ICE/Day",
    //     rentalTerm: "60Days",
    //     action: "Rent Me"
    // }, 

]